module.exports = __webpack_public_path__ + "static/media/xray3.39f4fdba.jpg";